<form [formGroup]="affordabilityService.form" (ngSubmit)="submit()">
  <div class="bg-white rounded mb-3 container-section">
    <formly-form
      [model]="affordabilityService.model"
      [form]="affordabilityService.form"
      [fields]="fields">
    </formly-form>
    <div class="py-3 mt-4 d-print-none">
      <button type="submit" class="btn btn-lg btn-primary px-5 get-results">Get results</button>
    </div>
  </div>
</form>
